import { updateItem } from "./firebasefunctions";
import { notifyAgentOnFileComplete } from "./helper";

// Marks a requested file as built: flips the (soft-deleted) request deal to
// Approved, stamps who approved it, and notifies the requesting agent.
//
// This lived as two near-identical copies (hero.jsx and SupervisorDashboard.jsx)
// and the File Requests page would have been a third — one shared helper so the
// flip and the notification can never drift apart between screens.
//
// Callers own the UX around it (toast, list refresh); this owns the data flow.
// A failed notification never undoes a successful completion — the file IS
// built either way.
export async function completeFileRequest(deal, user, users) {
  if (!deal?.createdat) return { success: false, error: "No deal id" };
  try {
    const res = await updateItem("deals", String(deal.createdat), {
      status: "Approved",
      approvedby: user?.id,
    });
    if (res !== "success") {
      return { success: false, error: "Write failed" };
    }
    try {
      await notifyAgentOnFileComplete({ ...deal, status: "Approved" }, users, user);
    } catch (notifyErr) {
      console.error("Failed to notify requesting agent:", notifyErr);
    }
    return { success: true };
  } catch (err) {
    console.error("Failed to mark completed:", err);
    return { success: false, error: err?.message };
  }
}
